import React, { Fragment } from 'react';
import Tag from './tag'
import { Link } from 'react-router-dom';

export default function Project({ project, CardStyle }) {
    const { title, bullets, img, tags, link, projectId } = project
    const hrstyle = { borderColor: 'var(--white)', borderWidth: 1 }
    const imageStyle = { width: 100, height: 100, borderRadius: 15, objectFit: 'cover' }
    const ProjectCard = () => {
        return (
            <Fragment>
                <h3 style={{ lineHeight: 1.2 }}>{title}</h3>
                <hr style={hrstyle} />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {img
                        ?
                        <img alt={title} src={img} style={imageStyle} />
                        :
                        // eslint-disable-next-line jsx-a11y/img-redundant-alt
                        <img alt='No Image - Saveliy Saunin' src='/Noimage.png' style={imageStyle} />
                    }
                    {tags && <ul>
                        {tags.map(tag => <Tag key={tag} tag={tag} />)}
                    </ul>}
                </div>
                <hr style={hrstyle} />
                {bullets && <ul>
                    {bullets.map(bullet =>
                        <li key={bullet.key}>
                            {bullet.desc}
                        </li>
                    )}
                </ul>}
            </Fragment>
        )
    }
    return (
        <Fragment>
            {projectId ?
                <Link style={CardStyle} className='popUp' to={`/project/${projectId}`}>
                    <ProjectCard />
                </Link>
                :
                <a style={CardStyle} className='popUp' href={link}>
                    <ProjectCard />
                </a>
            }
        </Fragment>
    );
}